/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';

const style = {
  paddingTop: '15px',
};

const AgreementsFooter = (props) => {
  const { isTseu } = props;
  return (
    <div className="row">
      {!isTseu &&
        <div className="col col-xs-12" style={style}>
          <b>
            TradeStation Securities, Inc.
          </b> and&nbsp;
          <b>TradeStation Technologies, Inc.
          </b> are each wholly owned subsidiaries of <b>TradeStation Group, Inc.</b>,
          both operating, and providing products and services, under the TradeStation brand and trademark.&nbsp;
          <b className="italic">
            When applying for, or
            purchasing, accounts, subscriptions, products and services, it is important that
            you know which company you will be dealing with.
          </b>
          <b>&nbsp;
            <a
              className="btn btn-info slimh_element fitv_element slimv_element reset_capitals"
              tabIndex="-1"
              href="https://uploads.tradestation.com/uploads/tradestation-group-inc-companies.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>
            &nbsp;for further important information explaining what this means.</b>
        </div>
      }
      {isTseu &&
        <div className="col col-xs-12" style={style}>
          <b>
            Securities, options, and futures trading is offered by TradeStation Europe B.V., which is
            registered with the Dutch Chamber of Commerce (no. 89426657) and regulated by the Dutch Authority
            for the Financial Markets in the Netherlands.
            <br />
          </b>
        </div>
      }
    </div>
  );
};

AgreementsFooter.propTypes = {
  isTseu: PropTypes.bool,
};

export default AgreementsFooter;
